import { z } from 'zod';
import { ExtendedTarificationSchema } from '../tarification/TarificationFormData';
import { isValidSelectorString } from '@/utils/validations/selector.validation';
import { MarginRateSchema } from '@/types/common/margin-rate.schema';

export const FlightSchema = ExtendedTarificationSchema.extend({
  name: z.string({ message: 'Le nom est requis' }),
  supplier: isValidSelectorString('Le fournisseur est requis'),
  currency: isValidSelectorString('La devise est requise'),
  marginRate: MarginRateSchema.optional(),
  sourceCountry: isValidSelectorString('Le pays est requis'),
  sourceCity: isValidSelectorString('La ville est requise').optional(),
  sourceAirport: isValidSelectorString('L’aéroport est requis').optional(),
  destinationCountry: isValidSelectorString('Le pays est requis'),
  destinationCity: isValidSelectorString('La ville est requise').optional(),
  destinationAirport: isValidSelectorString('L’aéroport est requis').optional(),
  shortDescription: z.string().optional(),
  longDescription: z.string().optional(),
}).superRefine((data, ctx) => {
  if (data.customTarif === 'true') {
    data.tarifs.forEach((tarif, tarifIndex) => {
      tarif.pricePartitions.forEach((partition, partitionIndex) => {
        if (
          partition.specialPrice === undefined ||
          partition.specialPrice === null ||
          !partition.specialPrice
        ) {
          ctx.addIssue({
            code: 'invalid_type',
            expected: 'number',
            received: 'undefined',
            path: [
              'tarifs',
              tarifIndex,
              'pricePartitions',
              partitionIndex,
              'specialPrice',
            ],
            message: 'Le tarif est requis',
          });
        }
      });
    });
  }
});

export type FlightFormData = z.infer<typeof FlightSchema>;
